(() => {
  if (window.dpacBookingEssentialsLoaded) return;
  window.dpacBookingEssentialsLoaded = true;
  function write(panel, selector, value) {
    const node = panel.querySelector(selector);
    if (node && node.textContent !== value) node.textContent = value;
  }
  function update() {
    document.querySelectorAll('#MainContent .product-details [data-dpac-booking-essentials]').forEach(panel => {
      let data;
      try { data = JSON.parse(panel.querySelector('[data-dpac-variant-data]').textContent); }
      catch { return; }
      const scope = panel.closest('.product-details');
      const id = scope?.querySelector('product-form-component form input[name="id"]')?.value || panel.dataset.selectedVariant;
      const variant = data.variants.find(v => String(v.id) === String(id));
      if (!variant) return;
      const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: data.currency || data.shopCurrency
      }).format(cents / 100);
      write(panel, '[data-dpac-total]', money(variant.price));
      write(panel, '[data-dpac-format]', variant.title);
      const client = window.appointlyClient;
      const service = client?.service;
      const config = client?.config || window.appointlyConfig;
      const matching = String(service?.productId) === String(panel.dataset.productId);
      const serviceVariant = matching && service.variants?.find(v => String(v.variantId) === String(id));
      const duration = Number(serviceVariant?.durationInMin);
      write(panel, '[data-dpac-duration]', Number.isFinite(duration) && duration > 0 ? duration + ' minutes' : 'Confirm in scheduler');
      const durationCopy = Number.isFinite(duration) && duration > 0
        ? 'Your selected reading is scheduled for ' + duration + ' minutes.'
        : 'Confirm the selected format’s duration in the scheduler.';
      scope.querySelectorAll('[data-dpac-service-duration]').forEach(node => {
        if (node.textContent !== durationCopy) node.textContent = durationCopy;
      });
      let depositText = 'Confirm in scheduler', balanceText = 'Confirm in scheduler';
      const settings = config?.depositPaymentSettings;
      if (serviceVariant && service.isFreeService === false && service.skipDeposit === false && settings?.isEnabled === true && settings.options?.length === 1) {
        const option = settings.options[0], value = Number(option.value), type = Number(option.type);
        let cents;
        if (type === 1 && Number.isFinite(value) && value >= 0 && value <= 100) cents = Math.round(variant.price * value / 100);
        if (type === 2 && data.currency === data.shopCurrency && Number.isFinite(value) && value >= 0) cents = Math.round(value * 100);
        if (Number.isFinite(cents) && cents >= 0 && cents <= variant.price) {
          depositText = money(cents) + (type === 1 ? ' (' + value + '%)' : '');
          balanceText = money(variant.price - cents);
        }
      }
      write(panel, '[data-dpac-deposit]', depositText);
      write(panel, '[data-dpac-balance]', balanceText);
      const teamNote = panel.querySelector('[data-dpac-team-note]');
      const team = serviceVariant?.teamMembers;
      const defaultLabel = team?.length === 1 && team[0].isDefault === true && team[0].name === 'Default';
      if (teamNote) {
        const note = defaultLabel ? '“Default” is the scheduler’s configured team label.' : '';
        if (teamNote.textContent !== note) teamNote.textContent = note;
        teamNote.hidden = !note;
      }
    });
  }
  document.addEventListener('change', () => { update(); setTimeout(update, 100); });
  document.addEventListener('DOMContentLoaded', update);
  const observer = new MutationObserver(update);
  observer.observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['value']});
  setInterval(() => { if (!document.hidden) update(); }, 1000);
  update();
})();
